import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appPlaca'
})
export class PlacaPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let newValue:string = (value || '').toString().toUpperCase().replace('-','').trim();
    let arrayValue = newValue.split('');
    if(arrayValue.length>3) {
      arrayValue.splice(2, 1, arrayValue[2] + '-');
      newValue = arrayValue.join('');
    }
    return newValue;
  }

}
